// The one money format of the app: N$1,234.56 (comma thousands, two
// decimals) whatever the browser's language; anything not a number is N$0.00.
// Every amount shown goes through here.
export const toCurrency = (n) => {
  const num = Number(n);
  return `N$${(Number.isFinite(num) ? num : 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export function usersMetrics(users = []) {
  const total = users.length;
  const active = users.filter(u => u.is_active).length;
  const inactive = total - active;
  const byRole = users.reduce((acc, u) => {
    const key = u.role_name || 'Unknown';
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});
  return { total, active, inactive, byRole };
}

// A loan that still owes money: paid out at some point (the API's
// state.approved: Approved, Outstanding, Paid Off, Bad Debt, Written off) with
// a positive total_due. Written-off loans stay in (owner's decision). The
// "Outstanding balance" list filter ('Owing') uses this same rule, so the
// Total Outstanding tile is exactly the sum of the loans that filter lists.
export const owesBalance = (l) =>
  Boolean(l?.state?.approved) && Number(l?.total_due) > 0;

export function loansMetrics(loans = []) {
  const counts = loans.reduce((acc, l) => {
    acc[l.status] = (acc[l.status] || 0) + 1;
    return acc;
  }, {});
  const approvalsPending = counts['Awaiting Approval'] || 0;
  // Σ total_due (the API's figure, penalties included) of the owing loans.
  const owing = loans.filter(owesBalance);
  const outstandingAmount = owing.reduce((sum, l) => sum + Number(l.total_due), 0);
  // Overdue is the API's instalment-based flag, never the final due date.
  const overdueCount = loans.filter(l => Boolean(l?.state?.is_overdue)).length;
  // Paid out at some point (the "Approved" list filter).
  const approvedCount = loans.filter(l => Boolean(l?.state?.approved)).length;
  return { approvalsPending, outstandingAmount, owingCount: owing.length, overdueCount, approvedCount, counts };
}

// New: simple counts for roles, interest rates, clients, and audits
export function rolesMetrics(roles = []) {
  const total = roles.length;
  const active = roles.filter(r => r.is_active).length;
  const inactive = total - active;
  return { total, active, inactive };
}

export function ratesMetrics(rates = []) {
  const total = rates.length;
  const active = rates.filter(r => r.is_active).length;
  const inactive = total - active;
  return { total, active, inactive };
}

export function clientsMetrics(clients = []) {
  const total = clients.length;
  const active = clients.filter(c => c?.personal_info?.is_active).length;
  const inactive = total - active;
  return { total, active, inactive };
}

export function auditsMetrics(audits = []) {
  const total = audits.length;
  const now = new Date();
  const today = audits.filter(a => {
    const d = a.created_at ? new Date(a.created_at) : null;
    if (!d || isNaN(d.getTime())) return false;
    return d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth() && d.getDate() === now.getDate();
  }).length;
  const uniqueUsers = new Set(audits.map(a => a.user_id)).size;
  return { total, today, uniqueUsers };
}
